import { render, staticRenderFns } from "./Events_Messages.vue?vue&type=template&id=19eb4004&scoped=true&"
import script from "./Events_Messages.vue?vue&type=script&lang=js&"
export * from "./Events_Messages.vue?vue&type=script&lang=js&"
import style0 from "./Events_Messages.vue?vue&type=style&index=0&id=19eb4004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19eb4004",
  null
  
)

export default component.exports